export default "__VITE_ASSET__CrH3gQYJ__"